<svg
  [attr.viewBox]="'0 0 400 400'"
  [ngClass]="className"
  xmlns="http://www.w3.org/2000/svg"
  style="overflow: visible;"
>
  <defs>
    <!-- Main gradient - purple to indigo -->
    <linearGradient [attr.id]="gradientId" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" [attr.stop-color]="primaryColor" />
      <stop offset="50%" [attr.stop-color]="secondaryColor" />
      <stop offset="100%" [attr.stop-color]="accentColor" />
    </linearGradient>

    <!-- Secondary gradient for accents -->
    <linearGradient [attr.id]="accentGradientId" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" [attr.stop-color]="glowColor" />
      <stop offset="100%" [attr.stop-color]="secondaryColor" />
    </linearGradient>

    <!-- Radial gradient for depth -->
    <radialGradient [attr.id]="radialGradientId">
      <stop offset="0%" [attr.stop-color]="glowColor" stop-opacity="0.8" />
      <stop offset="100%" [attr.stop-color]="secondaryColor" stop-opacity="0.4" />
    </radialGradient>

    <!-- Glow effect -->
    <filter [attr.id]="glowFilterId">
      <feGaussianBlur stdDeviation="4" result="coloredBlur" />
      <feMerge>
        <feMergeNode in="coloredBlur" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>

    <!-- Strong glow for highlights -->
    <filter [attr.id]="strongGlowFilterId">
      <feGaussianBlur stdDeviation="8" result="coloredBlur" />
      <feMerge>
        <feMergeNode in="coloredBlur" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>

  <!-- Background glow circles -->
  <circle cx="200" cy="200" r="160" [attr.fill]="'url(#' + radialGradientId + ')'" opacity="0.35" />

  <!-- Main prism structure -->
  <g [attr.filter]="'url(#' + glowFilterId + ')'">
    <!-- Center facet - brightest -->
    <polygon
      points="200,100 260,180 240,300 160,300 140,180"
      [attr.fill]="'url(#' + gradientId + ')'"
      opacity="0.9"
    />
    
    <!-- Left facet -->
    <path
      d="M 200,100 L 140,180 L 160,300 L 200,260 Z"
      [attr.fill]="primaryColor"
      opacity="0.7"
    />
    
    <!-- Right facet -->
    <path
      d="M 200,100 L 260,180 L 240,300 L 200,260 Z"
      [attr.fill]="'url(#' + accentGradientId + ')'"
      opacity="0.75"
    />

    <!-- Top edge highlight -->
    <polygon
      points="200,100 180,140 220,140"
      [attr.fill]="glowColor"
      opacity="0.6"
    />
  </g>

  <!-- AI Neural network pattern - connecting lines (behind nodes) -->
  <g [attr.stroke]="'url(#' + accentGradientId + ')'" stroke-width="1.5" opacity="0.3" fill="none">
    <!-- Layer 1 to Layer 2 -->
    <line x1="200" y1="100" x2="160" y2="140" />
    <line x1="200" y1="100" x2="200" y2="150" />
    <line x1="200" y1="100" x2="240" y2="140" />
    
    <!-- Layer 2 to Layer 3 -->
    <line x1="160" y1="140" x2="140" y2="180" />
    <line x1="160" y1="140" x2="200" y2="180" />
    <line x1="200" y1="150" x2="200" y2="180" />
    <line x1="240" y1="140" x2="200" y2="180" />
    <line x1="240" y1="140" x2="260" y2="180" />
    
    <!-- Layer 3 to Layer 4 -->
    <line x1="140" y1="180" x2="160" y2="230" />
    <line x1="200" y1="180" x2="160" y2="230" />
    <line x1="200" y1="180" x2="200" y2="230" />
    <line x1="200" y1="180" x2="240" y2="230" />
    <line x1="260" y1="180" x2="240" y2="230" />
    
    <!-- Layer 4 to Layer 5 -->
    <line x1="160" y1="230" x2="180" y2="270" />
    <line x1="200" y1="230" x2="180" y2="270" />
    <line x1="200" y1="230" x2="200" y2="280" />
    <line x1="200" y1="230" x2="220" y2="270" />
    <line x1="240" y1="230" x2="220" y2="270" />
  </g>

  <!-- AI Neural network nodes with glow -->
  <g [attr.filter]="'url(#' + strongGlowFilterId + ')'">
    <!-- Layer 1 - Top -->
    <circle cx="200" cy="100" r="7" [attr.fill]="glowColor" opacity="0.95" />
    
    <!-- Layer 2 -->
    <circle cx="160" cy="140" r="5" [attr.fill]="accentColor" opacity="0.9" />
    <circle cx="200" cy="150" r="5" [attr.fill]="glowColor" opacity="0.9" />
    <circle cx="240" cy="140" r="5" [attr.fill]="accentColor" opacity="0.9" />
    
    <!-- Layer 3 - Middle -->
    <circle cx="140" cy="180" r="6" [attr.fill]="primaryColor" opacity="0.85" />
    <circle cx="200" cy="180" r="6" [attr.fill]="glowColor" opacity="0.95" />
    <circle cx="260" cy="180" r="6" [attr.fill]="primaryColor" opacity="0.85" />
    
    <!-- Layer 4 -->
    <circle cx="160" cy="230" r="5" [attr.fill]="accentColor" opacity="0.9" />
    <circle cx="200" cy="230" r="6" [attr.fill]="glowColor" opacity="0.95" />
    <circle cx="240" cy="230" r="5" [attr.fill]="accentColor" opacity="0.9" />
    
    <!-- Layer 5 - Bottom -->
    <circle cx="180" cy="270" r="5" [attr.fill]="secondaryColor" opacity="0.85" />
    <circle cx="200" cy="280" r="5" [attr.fill]="accentColor" opacity="0.9" />
    <circle cx="220" cy="270" r="5" [attr.fill]="secondaryColor" opacity="0.85" />
  </g>

  <!-- Orbiting accent dots -->
  <g [attr.fill]="accentColor" opacity="0.5">
    <circle cx="320" cy="200" r="3" />
    <circle cx="280" cy="130" r="2.5" />
    <circle cx="120" cy="130" r="2.5" />
    <circle cx="80" cy="200" r="3" />
    <circle cx="120" cy="270" r="2.5" />
    <circle cx="280" cy="270" r="2.5" />
  </g>

  <!-- Subtle circular accents -->
  <g [attr.stroke]="accentColor" stroke-width="1.5" opacity="0.2" fill="none">
    <circle cx="200" cy="200" r="130" stroke-dasharray="4,12" />
    <circle cx="200" cy="200" r="90" stroke-dasharray="3,10" />
  </g>
</svg>
